import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/common/Header';
import Main from './components/home/Main';
import Dashboard from './components/dashboard/Dashboard';
import WalletConnect from './components/wallet/WalletConnect';
import Footer from './components/common/Footer';
import MainContent from './components/home/MainContent';
import WhatIsSBRaint from './components/home/WhatIsSBRaint';

const App = () => {
  const [account, setAccount] = useState(null);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', accounts => {
        setAccount(accounts.length > 0 ? accounts[0] : null);
      });

      window.ethereum.on('disconnect', () => {
        setAccount(null);
      });
    }
  }, []);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setAccount(accounts[0]);
      } catch (error) {
        console.error("Error connecting to Metamask", error);
      }
    } else {
      console.error("Metamask not found");
    }
  };

  const disconnectWallet = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({
          method: 'wallet_requestPermissions',
          params: [{
            eth_accounts: {}
          }]
        });
        setAccount(null);
        window.location.reload();  // This line ensures the application state is reset
      } catch (error) {
        console.error("Error disconnecting from Metamask", error);
      }
    } else {
      console.error("Metamask not found");
    }
  };

  return (
    <Router>
      <div className="App">
        <Header account={account} connectWallet={connectWallet} disconnectWallet={disconnectWallet} />
        <Routes>
          <Route path="/" element={<>
            <MainContent />
            
            <WhatIsSBRaint />

            <Main />
            
          </>} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/wallet" element={<WalletConnect account={account} />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
